<!-- <ng-container *ngIf="isLoading">
  <app-loader [isLoading]="isLoading"></app-loader>
</ng-container>
<ng-container  *ngIf="!isLoading">
<div class="registration-bg">
  <div class="row h-100 d-flex align-items-stretch">
    <div class="col-lg-10 mx-auto">
      <div class="card">
        <div class="card-body">
          <div class="login-form p-0">
            
            <div class="d-flex flex-wrap justify-content-between align-items-center  text-white p-3 rounded shadow-sm mb-2">
             

              <div class="text-center">
                <div class="d-flex gap-2">
                 <div>
                  <img src="../../assets/images/logos/hplogo.png" alt="HP Logo"
                  width="80"
                  class="bg-white p-2  shadow-sm" />
                 </div>

               <div>
                <h4 class="fw-bold mb-1">Department of Cooperation</h4>
                <p class="mb-1 fw-bold text-uppercase">Government of Himachal Pradesh</p>
        
               </div>
                   
                    </div>
                    </div>
                  <div class="text-start">
              
            
                <p class="mb-0 mt-2"><strong>Create Your Account</strong></p>
              </div>
            
            </div>

            <form [formGroup]="userForm">
              <div class="row">
                <div class="col-md-4 mb-2">
                  <label class="mb-1 text-dark"
                    >Name<span class="text-danger">*</span></label
                  >
                  <input
                    type="text"
                    class="form-control"
                    placeholder="Enter Full Name"
                    formControlName="sName"
                    [minlength]="5"
                    [maxlength]="40"
                    (keypress)="allowOnlyCharacters($event)"
                    [ngClass]="{
                      'invalid-input':
                        userForm.get('sName')?.errors && isSubmit
                    }"
                  />
                  <div *ngIf="userForm.get('sName')?.invalid && userForm.get('sName')?.touched">
                    <small class="text-danger" *ngIf="userForm.get('sName')?.errors?.['required']">
                      Name is required.
                    </small>
                    <small class="text-danger" *ngIf="userForm.get('sName')?.errors?.['minlength']">
                      Name must be greater than 5 character.
                    </small>
                    <small class="text-danger" *ngIf="userForm.get('sName')?.errors?.['maxlength']">
                      Name must be less than and equal to 40 character.
                    </small>
                    <small class="text-danger" *ngIf="userForm.get('sName')?.errors?.['pattern']">
                      Name must be only character.
                    </small>
                  </div>
                </div>
                <div class="col-md-4 mb-2">
                  <label class="mb-1 text-dark"
                    >Address Line 1<span class="text-danger">*</span></label
                  >
                  <input
                    type="text"
                    class="form-control"
                    placeholder="Enter Your Address"
                    formControlName="sAddressLine1"
                    (blur)="trimName('sAddressLine1')"
                    [maxlength]="100"
                    [ngClass]="{
                      'invalid-input':
                        userForm.get('sAddressLine1')?.errors && isSubmit
                    }"
                  />
                  <div *ngIf="userForm.get('sAddressLine1')?.invalid && userForm.get('sAddressLine1')?.touched">
                    <small class="text-danger" *ngIf="userForm.get('sAddressLine1')?.errors?.['required']">
                      Address Line 1 is required. Address Line 1 must be less than and equal to 100 character
                    </small>
                    <small class="text-danger" *ngIf="userForm.get('sAddressLine1')?.errors?.['maxlength']">
                      Address Line 1 must be less than and equal to 100 character.
                    </small>
                  </div>
                </div>
                <div class="col-md-4 mb-2">
                  <label class="mb-1 text-dark"
                    >Address Line 2</label
                  >
                  <input
                    type="text"
                    class="form-control"
                    placeholder="Enter Your Address"
                    formControlName="sAddressLine2"
                    (blur)="trimName('sAddressLine2')"
                    [maxlength]="100"
                    [ngClass]="{
                      'invalid-input':
                        userForm.get('sAddressLine2')?.errors && isSubmit
                    }"
                  />
                </div>

                <div class="col-md-4 mb-2">
                  <label class="mb-1 text-dark"
                    >Email<span class="text-danger">*</span></label
                  >

                  <div class="d-flex align-items-center" style="gap: 10px">
                    <div>
                      <input
                      type="text"
                      name="realPassword"
                      [attr.autocomplete]="'new-password'"
                      class="form-control"
                      placeholder="Enter Email Id"
                      formControlName="sEmailId"
                      minlength="5"
                      maxlength="50"
                      [ngClass]="{
                        'invalid-input': userForm.get('sEmailId')?.errors && isSubmit
                      }"
                      [readonly]="emailVerified"
                      />
                      <div *ngIf="userForm.get('sEmailId')?.invalid && userForm.get('sEmailId')?.touched">
                        <small class="text-danger" *ngIf="userForm.get('sEmailId')?.errors?.['required']">
                          Email is required.
                        </small>
                        <small class="text-danger" *ngIf="userForm.get('sEmailId')?.errors?.['minlength']">
                          Email must be more than or equal to 5 characters.
                        </small>
                        
                        <small class="text-danger" *ngIf="userForm.get('sEmailId')?.errors?.['pattern']">
                          Invalid  email format.
                        </small>
                      </div>
                  
                    </div>
                    <div >
                      <div >
                        <button type="button" *ngIf="!emailVerified" 
                                [disabled]="userForm.get('sEmailId')?.invalid" 
                                class="btn btn-sm btn-primary"
                                (click)="checkDuplicateEmailOrMobile(1)">
                          Verify
                        </button>
                      </div>
                      
                        <span id="verifiedMark" *ngIf="emailVerified" style="color: green;font-size: 10px;">✅ Verified </span>
                        
                      <input
                        type="text"
                        class="form-control d-none"
                        placeholder="OTP"
                        minlength="4"
                        maxlength="4"
                      />
                      <button type="button" class="btn btn-success d-none">
                        Verified
                      </button> 
                    
                
                    </div>

                  </div>
                </div>
            
                <input type="text" name="fakeUsername" autocomplete="username" style="display: none;" />
                <input type="password" name="fakePassword" autocomplete="current-password" style="display: none;" />

                <div class="col-md-4 mb-2 position-relative">
                  <label class="mb-1 text-dark"
                    >Mobile Number<span class="text-danger">*</span></label>
                  <div class="d-flex align-items-center" style="gap: 10px">
                    <div>
                      <input
                        type="text"
                        class="form-control"
                        placeholder="Mobile Number"
                        minlength="10"
                        maxlength="10"
                        formControlName="sMobile"
                        [pattern]="'^[0-9]*$'"
                        (keypress)="[allowOnlyNumbers($event),phoneVerfied = false]"
                        [ngClass]="{
                          'invalid-input':
                            userForm.get('sMobile')?.errors && isSubmit
                        }"
                        [readonly]="phoneVerfied"
                      />
                      <div *ngIf="userForm.get('sMobile')?.invalid && userForm.get('sMobile')?.touched">
                        <small class="text-danger" *ngIf="userForm.get('sMobile')?.errors?.['pattern']">
                          please Enter valid Mobile No
                        </small>
                        </div>

                    </div>
                    <div>
                      <button type="button" (click)="checkDuplicateEmailOrMobile(2)"  *ngIf="!phoneVerfied" [disabled]=" userForm.get('sMobile')?.invalid" class="btn btn-sm btn-primary">
                        Verify
                      </button>
                      <span id="verifiedMark" *ngIf="phoneVerfied" style="color: green;font-size: 10px;">✅ Verified </span>
                    </div>
                  </div>
                </div>

                <div class="col-md-4 mb-2" *ngIf="userForm.get('sPhone')?.value">
                  <label class="mb-1 text-dark"
                    >STD Code<span class="text-danger">*</span></label>
                  <input type="text" class="form-control" placeholder="Enter Your STD Code"
                    formControlName="sSTDcode"
                    [minlength]="4"
                    [maxlength]="5"
                    [pattern]="'^[0-9]*$'"
                    (keypress)="allowOnlyNumbers($event)"
                   [style]="{'border-color': userForm.get('sPhone')?.value ? '' : 'red'}"/>
                  <div *ngIf="userForm.get('sSTDcode')?.invalid && userForm.get('sSTDcode')?.touched">
                    <small class="text-danger" *ngIf="userForm.get('sSTDcode')?.errors?.['minlength']">
                      STD Code must be at least 4 digits
                    </small>
                    <small class="text-danger" *ngIf="userForm.get('sSTDcode')?.errors?.['maxlength']">
                      STD Code must not exceed 5 digits
                    </small>
                    <small class="text-danger" *ngIf="userForm.get('sSTDcode')?.errors?.['pattern']">
                      Only numbers are allowed
                    </small>
                     <small class="text-danger" *ngIf="userForm.get('sSTDcode')?.errors?.['required']">
                      STD Code is required
                    </small>
                  </div>
                </div>
                <div class="col-md-4 mb-2">
                  <label class="mb-1 text-dark">Landline Number</label>
                  <input
                    type="text"
                    class="form-control"
                    placeholder="Enter Your Landline Number"
                    formControlName="sPhone"
                   [minlength]="7"
                    [maxlength]="8"
                   
                    [pattern]="'^[0-9]*$'"
                    (keypress)="allowOnlyNumbers($event)"
                    [ngClass]="{
                      'invalid-input':
                        userForm.get('sPhone')?.errors && isSubmit
                    }"
                  />
                  <div *ngIf="userForm.get('sPhone')?.invalid && userForm.get('sPhone')?.touched">
                    <small class="text-danger" *ngIf="userForm.get('sPhone')?.errors?.['minlength']">
                      Landline Number must be at least 7 digits
                    </small>
                    <small class="text-danger" *ngIf="userForm.get('sPhone')?.errors?.['maxlength']">
                      Landline Number must not exceed 8 digits
                    </small>
                    <small class="text-danger" *ngIf="userForm.get('sPhone')?.errors?.['pattern']">
                      Only numbers are allowed
                    </small>
                  </div>
                </div>
              </div>

              <div class="row mb-1">
                <div class="col-md-4">
                  <div class="mb-2 position-relative">
                    <label class="mb-1 text-dark"
                      >Enter Password<span class="text-danger">*</span></label
                    >
                    <input
                      type="password"

                      id="spassword"

                      id="password"

                      class="form-control"
                      formControlName="sPassword"
                      (copy)="$event.preventDefault()"
                      (cut)="$event.preventDefault()"
                      (paste)="$event.preventDefault()"
                      
                      [minlength]="8"
                      [maxlength]="16"
                      [ngClass]="{
                        'invalid-input':
                          userForm.get('sPassword')?.errors && isSubmit
                      }"
                    />

                   
                    <div
                      *ngIf="
                        userForm.get('sPassword')?.dirty &&
                        userForm.get('sPassword')?.invalid
                      "
                      class="text-danger"
                    >
                      <div
                        *ngIf="userForm.get('sPassword')?.errors?.['required']"
                      >
                        Password is required.
                      </div>
                      <div
                        *ngIf="userForm.get('sPassword')?.errors?.['pattern'] || userForm.get('sPassword')?.errors?.['minlength']"
                      >
                        Password must be at least 8 characters, include
                        uppercase, lowercase, special character,a number and no
                        spaces.
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="position-relative">
                    <label class="mb-1 text-dark"
                      >Confirm Password<span class="text-danger"
                        >*</span
                      ></label
                    >
                    <input
                      type="password"
                      id="confirmPassword"
                      class="form-control"
                      formControlName="confirmPassword"
                      (keypress)="trimName('confirmPassword')"
                      (copy)="$event.preventDefault()"
                      (cut)="$event.preventDefault()"
                      (paste)="$event.preventDefault()"
                      [minlength]="8"
                      [maxlength]="16"
                      [ngClass]="{
                        'invalid-input':
                          userForm.get('confirmPassword')?.errors && isSubmit
                      }"
                    />
                    <div
                      class="text-danger"
                      *ngIf="userForm.hasError('passwordsMismatch')"
                    >
                      Passwords do not match.
                    </div>
                  </div>
                </div>
              </div>
              <div class="text-end mb-1">
                <button (click)="onSubmit()"  class="btn btn-primary btn-block">
                  Sign Up
                </button>
              </div>
              <h6 class="login-title mb-4"><span>Or continue with</span></h6>

              <p class="text-center mb-0">
                If you are already registered
                <a class="btn-link text-primary" [routerLink]="['/login']" href="javascript:void(0)"
                  >Login</a
                >
              </p>

<p class="text-center mt-2 mb-0"><a href="javascript:void(0)" class="fs-15 btn btn-info btn-sm" data-bs-toggle="modal" data-bs-target="#ProceedInstructionRegister">Proceed to Instruction</a></p>
            </form>
          </div>
        </div>
      </div>
    </div>
    <div class="col-lg-6 d-none">
      <div class="card h-100 mb-3">
        <div class="card-body">
          <div class="pages-left h-100">
            <div class="register-content p-0">
              <h5 class="text-start">Important Points</h5>

              <p class="fs-14px mb-0">
                For help in Registration process click on Proceed to
                Instruction.
              </p>
              <p>
                <a href="javascript:void(0)" class="fs-15 btn btn-info" data-bs-toggle="modal" data-bs-target="#ProceedInstructionRegister">Proceed to Instruction</a>
              </p>

              <div class="mb-3 text-start">
                <ul class="">
                  <li class="">
                    <h6>Password Criteria:</h6>
                  </li>
                  <li class="">
                    Password Should be at least 8 characters long
                  </li>
                  <li class="">
                    Password should contain at least 1 numeric digit
                  </li>
                  <li class="">
                    Password should contain at least 1 special character
                  </li>
                </ul>
              </div>
              <div class="mb-3 text-start">
                <ul class="">
                  <li class="">
                    <h6>Before pressing submitting registration consider:</h6>
                  </li>
                  <li class="">Verifying mobile number</li>
                  <li class="">Verifying email id</li>
                  <li class="">Enter Captcha</li>
                </ul>
              </div>

              <div class="text-start">
                <ul class="">
                  <li class="">
                    <h6>Registration Cooperative Societies:</h6>
                  </li>
                  <li class="">Register Your Account</li>
                  <li class="">Fill and Submit Memorandum of Association</li>
                  <li class="">Submit Registration Fee</li>
                  <li class="">Download Registration Certificate</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  </div>
</ng-container>-->

<!-- Modal -->
<div class="modal fade" id="ProceedInstructionRegister" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1"
  aria-labelledby="ProceedInstructionRegisterLabel" aria-hidden="true">
  <div class="modal-dialog modal-lg modal-dialog-scrollable modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="ProceedInstructionRegisterLabel">
          Instructions and Procedure for Online Registration
        </h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>

      <div class="modal-body bootstrap-accordion-scope">
        <div class="accordion" id="RegisterationaccordionExample">

          <!-- Accordion Item 1 -->
          <div class="accordion-item">
            <h2 class="accordion-header" id="headingTwo">
              <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                data-bs-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                Instructions for Online Registration of Society under HP Societies Act, 2006
              </button>
            </h2>
            <div id="collapseTwo" class="accordion-collapse collapse" aria-labelledby="headingTwo"
              data-bs-parent="#RegisterationaccordionExample">
              <div class="accordion-body">
                <!-- Step Table -->
                <div class="table-responsive">
                  <table class="table table-hover">
                    <tbody>
                      <tr>
                        <th class="text-center" style="width: 8%">Step 1</th>
                        <th><i class="fa fa-user"></i>&nbsp;Account Registration</th>
                      </tr>
                      <tr>
                        <td></td>
                        <td>
                          <ol>
                            <li>Fill the account registration form and submit. Note the system-generated ID.</li>
                            <li>Click the activation link and activate your account using Registration ID & code.</li>
                            <li>Log in using your credentials.</li>
                          </ol>
                        </td>
                      </tr>
                      <tr>
                        <th class="text-center">Step 2</th>
                        <th><i class="fa fa-list-alt"></i>&nbsp;Submit Memorandum of Association</th>
                      </tr>
                      <tr>
                        <td></td>
                        <td>
                          <ol>
                            <li>Fill basic society details.</li>
                            <li>Upload scanned copies of ID proofs and society byelaws (pdf).</li>
                            <li>Fill election details and upload proceedings.</li>
                          </ol>
                        </td>
                      </tr>
                      <tr>
                        <th class="text-center">Step 3</th>
                        <th><i class="fa fa-inr"></i>&nbsp;Submit Registration Fee</th>
                      </tr>
                      <tr>
                        <td></td>
                        <td>
                          Submit registration fee via eChallan and track application status.
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>

          <!-- Accordion Item 2 -->
          <div class="accordion-item">
            <h2 class="accordion-header" id="headingThree">
              <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                data-bs-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
                Instructions for Online Registration of Cooperative Society (Primary) under HP Cooperative Societies Act
              </button>
            </h2>
            <div id="collapseThree" class="accordion-collapse collapse" aria-labelledby="headingThree"
              data-bs-parent="#RegisterationaccordionExample">
              <div class="accordion-body">
                <div class="table-responsive">
                  <table class="table table-hover">
                    <tbody>
                      <tr>
                        <th class="text-center" style="width: 8%">Step 1</th>
                        <th><i class="fa fa-user"></i>&nbsp;Account Registration</th>
                      </tr>
                      <tr>
                        <td></td>
                        <td>
                          <ol>
                            <li>Fill the account registration form and submit.</li>
                            <li>Click activation link to activate account.</li>
                            <li>Log in with credentials.</li>
                          </ol>
                        </td>
                      </tr>
                      <tr>
                        <th class="text-center">Step 2</th>
                        <th><i class="fa fa-list-alt"></i>&nbsp;Submit Online Application Form</th>
                      </tr>
                      <tr>
                        <td></td>
                        <td>
                          <ol>
                            <li>Fill society details.</li>
                            <li>Upload society byelaws, membership documents, meeting proceedings.</li>
                            <li>Submit and monitor status of application.</li>
                          </ol>
                        </td>
                      </tr>
                      <tr>
                        <th class="text-center">Step 3</th>
                        <th><i class="fa fa-download"></i>&nbsp;Download e-Certificate</th>
                      </tr>
                      <tr>
                        <td></td>
                        <td>
                          After approval, download system-generated e-certificate.
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>

      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
      </div>
    </div>
  </div>
</div>





<div class="modal fade" id="otpPhoneModal" tabindex="-1" aria-labelledby="otpPhoneModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-sm modal-dialog-scrollable">

    <div class="modal-content">

      <div class="modal-header">
        <h5 class="modal-title" id="otpPhoneModalLabel">OTP Verification</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"
          (click)="closeOtPModel()"></button>
      </div>
      <div class="modal-body">
        <h6>Enter the OTP sent to your {{maskString}}</h6>
        <div class="row">
          <div class="col-md-12">
            <label class="mb-1 text-dark">OTP Number<span class="text-danger">*</span></label>
            <input type="text" class="form-control" [(ngModel)]="txtOTPNumber" minlength="6" maxlength="6"
              [pattern]="'^[0-9]*$'" (keypress)="[allowOnlyNumbers($event),phoneVerfied = false]" />
            <span class="text-danger">{{countdownMobile}}</span>
          </div>
        </div>

      </div>
      <div class="modal-header">
        <div class="row">
          <div class="col-md-12">
            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>&nbsp;
            <button type="button" class="btn btn-primary" (click)="verifyOTP(2)">Verify OTP</button>
          </div>
        </div>
      </div>

    </div>
  </div>
</div>
<div class="modal fade" id="otpEmailModal" tabindex="-1" aria-labelledby="otpEmailModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-md modal-dialog-scrollable">

    <div class="modal-content">

      <div class="modal-header">
        <h5 class="modal-title" id="otpEmailModalLabel">OTP Verification</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"
          (click)="closeOtPModel()"></button>
      </div>
      <div class="modal-body">
        <h6>Enter the OTP sent to your {{maskString}}</h6>
        <div class="row">
          <div class="col-md-12">
            <label class="mb-1 text-dark">OTP Number<span class="text-danger">*</span></label>
            <input type="text" class="form-control" [(ngModel)]="txtOTPNumberEmail" minlength="6" maxlength="6"
              [pattern]="'^[0-9]*$'" (keypress)="[allowOnlyNumbers($event),phoneVerfied = false]" />
            <span class="text-danger">{{countdownEmail}}</span>
          </div>
        </div>

      </div>
      <div class="modal-header">
        <div class="row">
          <div class="col-md-12">
            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>&nbsp;
            <button type="button" class="btn btn-primary" (click)="verifyOTP(1)">Verify OTP</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
















<style>
 .form-scroll-container {
  max-height: 70vh;
  overflow-y: auto;
  overflow-x: hidden;
  padding-right: 10px;
}


  .form-scroll-container::-webkit-scrollbar-thumb {
    background-color: #ccc;
    border-radius: 4px;
  }
</style>

<div
  class="main-container font-sans antialiased text-slate-900 dark:text-slate-100 bg-slate-50 dark:bg-slate-950 transition-colors duration-500 overflow-hidden relative selection:bg-blue-500/30">

  <!-- Background Layers -->
  <div class="fixed inset-0 z-0 bg-slate-50 dark:bg-[#050A14] transition-colors duration-500"></div>

  <!-- Abstract Shapes -->
  <div class="fixed inset-0 z-0 overflow-hidden pointer-events-none">
    <div
      class="absolute -top-[10%] -left-[10%] w-[50vw] h-[50vw] rounded-full bg-blue-600/20 blur-[120px] mix-blend-multiply dark:mix-blend-screen animate-pulse"
      style="animation-duration: 10s"></div>
    <div
      class="absolute top-[20%] right-[10%] w-[30vw] h-[30vw] rounded-full bg-purple-500/20 blur-[100px] mix-blend-multiply dark:mix-blend-screen animate-pulse"
      style="animation-duration: 12s; animation-delay: 1s;"></div>
    <div
      class="absolute -bottom-[10%] left-[20%] w-[40vw] h-[40vw] rounded-full bg-teal-500/20 blur-[100px] mix-blend-multiply dark:mix-blend-screen animate-pulse"
      style="animation-duration: 15s; animation-delay: 2s;"></div>
  </div>

  <div class="fixed inset-0 z-0 texture-overlay"></div>
  <div class="absolute top-0 left-0 w-full z-50 px-6 py-4 flex justify-end items-center">
    <!-- Buttons -->
    <div class="flex items-center gap-3">
      <button (click)="toggleTheme()" class="rounded-full w-10 h-10 flex items-center justify-center 
         bg-white/40 hover:bg-white/60 dark:bg-black/20 dark:hover:bg-black/40 
         backdrop-blur-md border border-white/20 dark:border-white/10 shadow-sm 
         transition-all hover:scale-105 cursor-pointer">
        <i class="bi" [ngClass]="isDark ? 'bi-moon-fill text-yellow-400' : 'bi-lightbulb-fill text-yellow-400'"></i>
      </button>


      <button (click)="toggleLanguage()"
        class="rounded-full px-5 h-10 flex items-center bg-gov-navy text-white hover:bg-blue-900 dark:bg-blue-600 dark:hover:bg-blue-500 shadow-md transition-all hover:scale-105 border border-transparent cursor-pointer">
        <i class="bi bi-globe me-2"></i>
        <span id="lang-text" class="text-xs font-bold tracking-wide">
          {{ !isEnglish ? 'HINDI' : 'ENGLISH' }}
        </span>
      </button>
    </div>
  </div>
  <!-- Main Panels -->
  <div class="z-10 w-full flex items-center justify-center p-4 lg:p-8 relative h-screen">

    <div
      class="w-full max-w-6xl h-full lg:h-[85vh] flex flex-col lg:flex-row overflow-hidden rounded-[2rem] shadow-2xl glass-panel ring-1 ring-black/5 dark:ring-white/5">

      <!-- Left Panel (Hero) -->
      <div class="left-panel relative hidden lg:flex w-1/2 flex-col justify-between p-12 overflow-hidden group">

        <div class="absolute inset-0 z-0 bg-gradient-to-br from-blue-900/90 to-slate-900/90 mix-blend-multiply z-10">
        </div>
        <img src="https://images.unsplash.com/photo-1497366216548-37526070297c?auto=format&fit=crop&q=80&w=1000"
          alt="Background"
          class="absolute inset-0 w-full h-full object-cover opacity-40 scale-105 transition-transform duration-[20s] ease-linear group-hover:scale-110 z-[-1]">

        <div class="relative z-20">
          <!-- <div
            class="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-white/10 backdrop-blur-md border border-white/10 text-blue-100 text-xs font-medium mb-6">
            <span class="w-2 h-2 rounded-full bg-emerald-400 animate-pulse"></span>
            Official Portal
          </div> -->

          <div class="mb-6 flex justify-center">
            <img src="../../assets/images/logos/hplogo.png" alt="HP Logo" class="w-32 h-auto object-contain">
          </div>

          <h1 id="hero-title" class="text-5xl font-bold font-heading text-white leading-[1.15] mb-6 drop-shadow-sm">
            {{ translations.signUpTitle }}
          </h1>
          <p id="hero-desc" class="text-blue-100/80 text-lg leading-relaxed max-w-md">
            {{ translations.signUpDesc }}
          </p>
        </div>

        <div class="relative z-20 space-y-6">
          <div class="grid grid-cols-2 gap-4">

          </div>
        <p id="footer-text" class="text-xs text-blue-200/60 font-medium tracking-wide">
  © {{ currentYear }} Government of Himachal Pradesh
</p>

        </div>
      </div>

      <!-- Right Panel (Form) -->
      <div
        class="right-panel w-full lg:w-1/2 bg-white/40 dark:bg-black/20 backdrop-blur-md flex flex-col justify-center p-8 sm:p-12 lg:p-16 relative">

        <div class="max-w-sm mx-auto w-full space-y-8">
          <div class="text-center lg:text-left space-y-2">
            <h2 id="welcome-text" class="text-3xl font-bold text-slate-800 dark:text-white tracking-tight">
              {{ translations.signUpTitle }}
            </h2>
          </div>

          <form [formGroup]="userForm">
            <div class="form-scroll-container">

              <div class="row g-3">

                <div class="col-md-12 mb-2">
                  <label class="mb-1 text-dark">Name<span class="text-danger">*</span></label>
                  <input type="text" class="form-control" placeholder="Enter Full Name" formControlName="sName"
                    [minlength]="5" [maxlength]="40" (keypress)="allowOnlyCharacters($event)" [ngClass]="{
                      'invalid-input':
                        userForm.get('sName')?.errors && isSubmit
                    }" />
                  <div *ngIf="userForm.get('sName')?.invalid && userForm.get('sName')?.touched">
                    <small class="text-danger" *ngIf="userForm.get('sName')?.errors?.['required']">
                      Name is required.
                    </small>
                    <small class="text-danger" *ngIf="userForm.get('sName')?.errors?.['minlength']">
                      Name must be greater than 5 character.
                    </small>
                    <small class="text-danger" *ngIf="userForm.get('sName')?.errors?.['maxlength']">
                      Name must be less than and equal to 40 character.
                    </small>
                    <small class="text-danger" *ngIf="userForm.get('sName')?.errors?.['pattern']">
                      Name must be only character.
                    </small>
                  </div>
                </div>
                <div class="col-md-12 mb-2">
                  <label class="mb-1 text-dark">Address Line 1<span class="text-danger">*</span></label>
                  <input type="text" class="form-control" placeholder="Enter Your Address"
                    formControlName="sAddressLine1" (blur)="trimName('sAddressLine1')" [maxlength]="100" [ngClass]="{
                      'invalid-input':
                        userForm.get('sAddressLine1')?.errors && isSubmit
                    }" />
                  <div *ngIf="userForm.get('sAddressLine1')?.invalid && userForm.get('sAddressLine1')?.touched">
                    <small class="text-danger" *ngIf="userForm.get('sAddressLine1')?.errors?.['required']">
                      Address Line 1 is required. Address Line 1 must be less than and equal to 100 character
                    </small>
                    <small class="text-danger" *ngIf="userForm.get('sAddressLine1')?.errors?.['maxlength']">
                      Address Line 1 must be less than and equal to 100 character.
                    </small>
                  </div>
                </div>
                <div class="col-md-12 mb-2">
                  <label class="mb-1 text-dark">Address Line 2</label>
                  <input type="text" class="form-control" placeholder="Enter Your Address"
                    formControlName="sAddressLine2" (blur)="trimName('sAddressLine2')" [maxlength]="100" [ngClass]="{
                      'invalid-input':
                        userForm.get('sAddressLine2')?.errors && isSubmit
                    }" />
                </div>

                <div class="col-md-12 mb-2">
                  <label class="mb-1 text-dark">Email<span class="text-danger">*</span></label>

                  <div class="d-flex align-items-center" style="gap: 10px">
                    <div>
                      <input type="text" name="realPassword" [attr.autocomplete]="'new-password'" class="form-control"
                        placeholder="Enter Email Id" formControlName="sEmailId" minlength="5" maxlength="50" [ngClass]="{
                        'invalid-input': userForm.get('sEmailId')?.errors && isSubmit
                      }" [readonly]="emailVerified" />
                      <div *ngIf="userForm.get('sEmailId')?.invalid && userForm.get('sEmailId')?.touched">
                        <small class="text-danger" *ngIf="userForm.get('sEmailId')?.errors?.['required']">
                          Email is required.
                        </small>
                        <small class="text-danger" *ngIf="userForm.get('sEmailId')?.errors?.['minlength']">
                          Email must be more than or equal to 5 characters.
                        </small>

                        <small class="text-danger" *ngIf="userForm.get('sEmailId')?.errors?.['pattern']">
                          Invalid email format.
                        </small>
                      </div>

                    </div>
                    <div>
                      <div>
                        <button type="button" *ngIf="!emailVerified" [disabled]="userForm.get('sEmailId')?.invalid"
                          class="btn btn-sm btn-primary" (click)="checkDuplicateEmailOrMobile(1)">
                          Verify
                        </button>
                      </div>

                      <span id="verifiedMark" *ngIf="emailVerified" style="color: green;font-size: 10px;">✅ Verified
                      </span>

                      <input type="text" class="form-control d-none" placeholder="OTP" minlength="4" maxlength="4" />
                      <button type="button" class="btn btn-success d-none">
                        Verified
                      </button>


                    </div>

                  </div>
                </div>

                <input type="text" name="fakeUsername" autocomplete="username" style="display: none;" />
                <input type="password" name="fakePassword" autocomplete="current-password" style="display: none;" />

                <div class="col-md-12 mb-2 position-relative">
                  <label class="mb-1 text-dark">Mobile Number<span class="text-danger">*</span></label>
                  <div class="d-flex align-items-center" style="gap: 10px">
                    <div>
                      <input type="text" class="form-control" placeholder="Mobile Number" minlength="10" maxlength="10"
                        formControlName="sMobile" [pattern]="'^[0-9]*$'"
                        (keypress)="[allowOnlyNumbers($event),phoneVerfied = false]" [ngClass]="{
                          'invalid-input':
                            userForm.get('sMobile')?.errors && isSubmit
                        }" [readonly]="phoneVerfied" />
                      <div *ngIf="userForm.get('sMobile')?.invalid && userForm.get('sMobile')?.touched">
                        <small class="text-danger" *ngIf="userForm.get('sMobile')?.errors?.['pattern']">
                          please Enter valid Mobile No
                        </small>
                      </div>

                    </div>
                    <div>
                      <button type="button" (click)="checkDuplicateEmailOrMobile(2)" *ngIf="!phoneVerfied"
                        [disabled]=" userForm.get('sMobile')?.invalid" class="btn btn-sm btn-primary">
                        Verify
                      </button>
                      <span id="verifiedMark" *ngIf="phoneVerfied" style="color: green;font-size: 10px;">✅ Verified
                      </span>
                    </div>
                  </div>
                </div>

                <div class="col-md-12 mb-2" *ngIf="userForm.get('sPhone')?.value">
                  <label class="mb-1 text-dark">STD Code<span class="text-danger">*</span></label>
                  <input type="text" class="form-control" placeholder="Enter Your STD Code" formControlName="sSTDcode"
                    [minlength]="4" [maxlength]="5" [pattern]="'^[0-9]*$'" (keypress)="allowOnlyNumbers($event)"
                    [style]="{'border-color': userForm.get('sPhone')?.value ? '' : 'red'}" />
                  <div *ngIf="userForm.get('sSTDcode')?.invalid && userForm.get('sSTDcode')?.touched">
                    <small class="text-danger" *ngIf="userForm.get('sSTDcode')?.errors?.['minlength']">
                      STD Code must be at least 4 digits
                    </small>
                    <small class="text-danger" *ngIf="userForm.get('sSTDcode')?.errors?.['maxlength']">
                      STD Code must not exceed 5 digits
                    </small>
                    <small class="text-danger" *ngIf="userForm.get('sSTDcode')?.errors?.['pattern']">
                      Only numbers are allowed
                    </small>
                    <small class="text-danger" *ngIf="userForm.get('sSTDcode')?.errors?.['required']">
                      STD Code is required
                    </small>
                  </div>
                </div>
                <div class="col-md-12 mb-2">
                  <label class="mb-1 text-dark">Landline Number</label>
                  <input type="text" class="form-control" placeholder="Enter Your Landline Number"
                    formControlName="sPhone" [minlength]="7" [maxlength]="8" [pattern]="'^[0-9]*$'"
                    (keypress)="allowOnlyNumbers($event)" [ngClass]="{
                      'invalid-input':
                        userForm.get('sPhone')?.errors && isSubmit
                    }" />
                  <div *ngIf="userForm.get('sPhone')?.invalid && userForm.get('sPhone')?.touched">
                    <small class="text-danger" *ngIf="userForm.get('sPhone')?.errors?.['minlength']">
                      Landline Number must be at least 7 digits
                    </small>
                    <small class="text-danger" *ngIf="userForm.get('sPhone')?.errors?.['maxlength']">
                      Landline Number must not exceed 8 digits
                    </small>
                    <small class="text-danger" *ngIf="userForm.get('sPhone')?.errors?.['pattern']">
                      Only numbers are allowed
                    </small>
                  </div>
                </div>
              </div>

              <div class="row mb-1">
                <div class="col-md-12">
                  <div class="mb-2 position-relative">
                    <label class="mb-1 text-dark">Enter Password<span class="text-danger">*</span></label>
                    <input type="password" id="spassword" id="password" class="form-control" formControlName="sPassword"
                      (copy)="$event.preventDefault()" (cut)="$event.preventDefault()" (paste)="$event.preventDefault()"
                      [minlength]="8" [maxlength]="16" [ngClass]="{
                        'invalid-input':
                          userForm.get('sPassword')?.errors && isSubmit
                      }" />


                    <div *ngIf="
                        userForm.get('sPassword')?.dirty &&
                        userForm.get('sPassword')?.invalid
                      " class="text-danger">
                      <div *ngIf="userForm.get('sPassword')?.errors?.['required']">
                        Password is required.
                      </div>
                      <div
                        *ngIf="userForm.get('sPassword')?.errors?.['pattern'] || userForm.get('sPassword')?.errors?.['minlength']">
                        Password must be at least 8 characters, include
                        uppercase, lowercase, special character,a number and no
                        spaces.
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-12">
                  <div class="position-relative">
                    <label class="mb-1 text-dark">Confirm Password<span class="text-danger">*</span></label>
                    <input type="password" id="confirmPassword" class="form-control" formControlName="confirmPassword"
                      (keypress)="trimName('confirmPassword')" (copy)="$event.preventDefault()"
                      (cut)="$event.preventDefault()" (paste)="$event.preventDefault()" [minlength]="8" [maxlength]="16"
                      [ngClass]="{
                        'invalid-input':
                          userForm.get('confirmPassword')?.errors && isSubmit
                      }" />
                    <div class="text-danger" *ngIf="userForm.hasError('passwordsMismatch')">
                      Passwords do not match.
                    </div>
                  </div>
                </div>
              </div>
              <br />
              <div class="text-end mb-3">
                <button (click)="onSubmit()" class="btn btn-primary btn-block">
                  {{ translations.signUp }}
                </button>
              </div>

              <p class="text-center mb-3">
                {{ translations.alreadyHaveAccount }}
                <a class="btn-link text-primary" [routerLink]="['/login']" href="javascript:void(0)">
                  {{ translations.loginHere }}
                </a>
              </p>

              <div class="text-center mt-3">
                <button class="btn btn-info btn-sm" data-bs-toggle="modal" data-bs-target="#ProceedInstructionRegister">
                  Proceed to Instruction
                </button>
              </div>

            </div>
          </form>

        </div>


      </div>

    </div>
  </div>
</div>